export default "__VITE_ASSET__siYmeFVd__"